/**
 * i18n.js
 *
 * This will setup the i18n language files and locale data for your app.
 *
 */
import flatten from 'flat';
import enTranslationMessages from './translations/en.json';
import frTranslationMessages from './translations/fr.json';

import { DEFAULT_LOCALE } from 'services/Language/actions';

export const formatTranslationMessages = (locale, messages) => {
  const defaultFormattedMessages =
    locale !== DEFAULT_LOCALE ? formatTranslationMessages(DEFAULT_LOCALE, flatten(enTranslationMessages)) : {};
  const formattedMessages = {};
  const messageKeys = Object.keys(messages);

  for (const messageKey of messageKeys) {
    if (locale === DEFAULT_LOCALE) {
      formattedMessages[messageKey] = messages[messageKey];
    } else {
      formattedMessages[messageKey] = messages[messageKey] || defaultFormattedMessages[messageKey];
    }
  }

  return formattedMessages;
};

export const translationMessages = {
  en: formatTranslationMessages('en-CA', flatten(enTranslationMessages)),
  fr: formatTranslationMessages('fr-CA', flatten(frTranslationMessages)),
};
